import { LockOpen } from "lucide-react";
import { loadImg, iconImg, roundRect, text, drawBackground, drawBrand, drawCta, drawAvatar } from "@/lib/badgeImage";

const L = {
  story: { W: 1080, H: 1920, logoY: 150, cardY: 430, cardH: 660, labelY: 1190, nameY: 1450, avatarY: 1310, ctaY: 1560, ctaH: 250 },
  square: { W: 1080, H: 1080, logoY: 90, cardY: 190, cardH: 420, labelY: 680, nameY: 760, avatarY: null, ctaY: 880, ctaH: 160 },
};

export async function renderVaultImage({ pot, code, no, user, format }) {
  const P = L[format], { W } = P;
  const c = document.createElement("canvas"); c.width = W; c.height = P.H;
  const ctx = c.getContext("2d");
  await document.fonts?.ready;
  const [icon, avatar] = await Promise.all([iconImg(LockOpen, "#FCD34D"), loadImg(user.picture, true)]);
  drawBackground(ctx, W, P.H);
  await drawBrand(ctx, W, P.logoY, format === "story" ? 1.2 : 1);
  const x = 110, w = W - 220, y = P.cardY, h = P.cardH;
  ctx.shadowColor = "rgba(180,83,9,0.55)"; ctx.shadowBlur = 80; ctx.shadowOffsetY = 24;
  const g = ctx.createLinearGradient(x, y, x + w, y + h); g.addColorStop(0, "#0F172A"); g.addColorStop(1, "#1E293B");
  roundRect(ctx, x, y, w, h, 60); ctx.fillStyle = g; ctx.fill(); ctx.shadowColor = "transparent";
  ctx.lineWidth = 14; ctx.strokeStyle = "#F59E0B"; roundRect(ctx, x + 10, y + 10, w - 20, h - 20, 52); ctx.stroke();
  const is = h * 0.15;
  if (icon) ctx.drawImage(icon, W / 2 - is / 2, y + h * 0.07, is, is);
  text(ctx, `TRESOR #${no} GEKNACKT!`, W / 2, y + h * 0.33, { size: h * 0.07, weight: 800, color: "#FCD34D", maxW: w - 80, fit: true });
  text(ctx, `+${pot}`, W / 2, y + h * 0.62, { size: h * 0.3, weight: 900, color: "#FBBF24" });
  text(ctx, "PUNKTE", W / 2, y + h * 0.75, { size: h * 0.06, weight: 800, color: "rgba(255,255,255,0.7)" });
  text(ctx, `Code: ${code.split("").join(" · ")}`, W / 2, y + h * 0.9, { size: h * 0.06, weight: 800, color: "#FDE68A" });
  text(ctx, "den Goldenen Tresor geknackt 🔓", W / 2, P.labelY, { size: format === "story" ? 56 : 46, weight: 800, maxW: W - 120, fit: true });
  if (P.avatarY) drawAvatar(ctx, avatar, user.name, W / 2, P.avatarY, 64);
  text(ctx, user.name, W / 2, P.nameY, { size: format === "story" ? 50 : 42, weight: 700, maxW: W - 200, color: "rgba(255,255,255,0.95)" });
  await drawCta(ctx, W, P.ctaY, P.ctaH, { code: user.referral_code, title: "Knack den nächsten Tresor & sammle Punkte" });
  return new Promise((resolve) => c.toBlob((b) => resolve(b), "image/png"));
}
